import styled, { createGlobalStyle } from "styled-components";

// Sobreescribe el width del modal de soporte sin afectar al resto de modales.
// También neutraliza el :focus heredado del GlobalStyle que pinta el botón
// disparador de rojo cuando Fluent UI le devuelve el foco al cerrar el modal.
export const SupportModalGlobalStyle = createGlobalStyle`
    .support-ticket-modal .ms-Dialog-main
    {
        width: 680px !important;
        max-width: 95vw !important;
    }

    .support-button.tiny-secondary-button:focus,
    .support-button.tiny-secondary-button:focus-visible
    {
        background: #ffffff !important;
        border-color: #cc214f !important;
        color: #cc214f !important;
        outline: none !important;
    }
`;

// Contenedor del botón disparador — mantiene el espacio reservado en el layout
export const TicketSupportContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 16px;
    margin-bottom: 16px;
    min-height: 54px;
    @media screen and (max-width: 599px)
    {
        justify-content: center;
        margin-top: 0px;
        width: 100%;
    }
`;

export const SupportTriggerCont = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
`;

// Contenido interno del Modal de Fluent UI
export const SupportModalOverlay = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0;
    border-radius: 8px;
    overflow: hidden;
`;

export const SupportModalHeader = styled.div`
    background-color: #ffffff;
    padding: 20px 24px 0;

    &::after
    {
        content: "";
        display: block;
        margin: 16px 2px 0;
        height: 2px;
        background-color: #cc214f;
        border-radius: 2px;
    }
`;

export const SupportModalTitle = styled.h2`
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #323130;
    cursor: default;
    font-family: Barlow, sans-serif;
`;

export const SupportModalBody = styled.div`
    padding: 24px 24px 8px;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const SupportDropdownWrapper = styled.div`
    .ms-Dropdown-title,
    .ms-Dropdown-caretDownWrapper
    {
        border-color: #d0d0d0;
    }
`;

export const SupportTextareaWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const SupportTextareaLabel = styled.label`
    font-size: 14px;
    font-weight: 600;
    color: #323130;
    font-family: Barlow, sans-serif;

    span
    {
        color: #cc214f;
        margin-left: 2px;
    }
`;

export const SupportTextarea = styled.textarea`
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    font-size: 14px;
    font-family: Barlow, sans-serif;
    color: #323130;
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    resize: vertical;
    min-height: 120px;
    outline: none;
    transition: border-color 0.15s ease;

    &:focus
    {
        outline: none;
        border-color: #cc214f;
    }

    &:disabled
    {
        background-color: #f4f4f4;
        color: #a19f9d;
        cursor: not-allowed;
    }

    &::placeholder
    {
        color: #a19f9d;
    }
`;

export const SupportCharCounter = styled.span<{ isNearLimit: boolean }>`
    font-size: 12px !important;
    text-align: right;
    color: ${({isNearLimit}) => (isNearLimit ? "#cc214f" : "#a19f9d")};
    font-family: Barlow, sans-serif;
    transition: color 0.2s ease;
`;

export const SupportModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px 24px 24px;
    border-top: 1px solid #edebe9;
`;